import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { SITE_ID_FETCH_SUCCESS } from "../../../Reducer/SiteIdSlice";
import { useEffect, useState } from "react";
import SiteAlarmNav from "./SiteAlarmNav";
import API, { cancelAllRequests, createController } from "../../../Network/API";
import AcsExportButton from "../../../CustomHook/AcsExportButton";
import CountdownTimer from "../../../Props/CountdownTimer";

export default function SiteAlarm() {

    const [dateValue, setDateChange] = useState('')
    const [to_date, setToDateChange] = useState('')
    const [get_data, setData] = useState()
    const [alarm_type, setAlarmType] = useState('')
    const [acs_nav, setNavData] = useState([])
    const [loading, setLoading] = useState(false)
    const ddd = useParams();
    const dispatch = useDispatch()
    useEffect(() => {
        setLoading(true);
         cancelAllRequests();
                const controller = createController();
                const signal = controller.signal;
        const loaderElement = document.querySelector(".loading-mask");
        loaderElement.removeAttribute('hidden');
        loaderElement.setAttribute('visible', 'true');
        dispatch(SITE_ID_FETCH_SUCCESS(ddd.id))

        API.get('/v1/oauth/site_alarm?site_id=' + ddd.id, { signal }).then((response) => {
            if (loaderElement) {
                if (loaderElement && !loaderElement.hasAttribute('hidden')) {
                    loaderElement.setAttribute('hidden', 'true');
                }
            }
            setLoading(false);
            setData(response.data.data)
        }).catch((error) => {
            setLoading(false);
            if (loaderElement) {
                if (loaderElement && !loaderElement.hasAttribute('hidden')) {
                    loaderElement.setAttribute('hidden', 'true');
                }
            }
        });

        API.get('/v1/oauth/acs_site_wise_alarm_nav', { signal }).then((response) => {
            setNavData(response.data.data)
        }).catch((error) => {
        });



    }, [ddd.id]);


    const clearSearch=()=>{
        const loaderElement = document.querySelector(".loading-mask");
        loaderElement.removeAttribute('hidden');
        loaderElement.setAttribute('visible', 'true');
        API.get('/v1/oauth/site_alarm?site_id=' + ddd.id).then((response) => {
            if (loaderElement) {
                if (loaderElement && !loaderElement.hasAttribute('hidden')) {
                    loaderElement.setAttribute('hidden', 'true');
                }
            }
            setLoading(false);
            setData(response.data.data)
        }).catch((error) => {
            setLoading(false);
            if (loaderElement) {
                if (loaderElement && !loaderElement.hasAttribute('hidden')) {
                    loaderElement.setAttribute('hidden', 'true');
                }
            }
        });
    }

 

    const search = () => {
        setLoading(true);
        const loaderElement = document.querySelector(".loading-mask");
        loaderElement.removeAttribute('hidden');
        loaderElement.setAttribute('visible', 'true');
        var pagea = '/v1/oauth/site_alarm?site_id=' + ddd.id + '&start_date=' + dateValue + '&end_date=' + to_date+'&alarm_type='+alarm_type
        API.get(pagea).then((response) => {
            if (loaderElement) {
                if (loaderElement && !loaderElement.hasAttribute('hidden')) {
                    loaderElement.setAttribute('hidden', 'true');
                }
            }
            setLoading(false);
            setData(response.data.data)

        }).catch((error) => {
            setLoading(false);
            if (loaderElement) {
                if (loaderElement && !loaderElement.hasAttribute('hidden')) {
                    loaderElement.setAttribute('hidden', 'true');
                }
            }
        });
    }

    return (
        <>
            <div className="row">
                <SiteAlarmNav id={1} site_id={ddd.id} />
            </div>
            <div className="row ms-1 me-1 mb-1">
                <div class="align-items-center d-flex">
                    <b class="main-card-title mb-0 flex-grow-1"></b>
                    <div class="flex-shrink-0">
                        <div class="">


                            <div class="input-group input-group-sm">
                                <div class="custom-dropdown-grop-btn me-2">
                                    <select className="form-select" onChange={(e)=>setAlarmType(e.target.value)}>
                                        <option value={``}>All Alarm Types</option>
                                        {acs_nav.lock_alarms?.map((lock_alarm, index) => (
                                            <option value={lock_alarm.order_list}>
                                                {lock_alarm.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <input value={dateValue} autoFocus={true} onChange={(e) => setDateChange(e.target.value)} type="date" class="form-control" autocomplete="off" />
                                <span class="input-group-text">To</span>
                                <input value={to_date} autoFocus={true} onChange={(e) => setToDateChange(e.target.value)} type="date" class="form-control" placeholder="" autocomplete="off" />
                                <a href="#" onClick={() => search()} class=" input-group-text text-white bg-success"><i className="fa-light fa-search" /></a>
                                <a href="#" onClick={() => clearSearch()} class="input-group-text bg-warning"><i className="fa-light fa-sync" /></a>
                                 <AcsExportButton className="btn btn-info" tableId="overload" fileName="acs_alarms" />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row ms-1 me-1">
                <div className="border-0 mt-2">
                    <div>
                        <table className="table table-bordered table-striped m-0 table-sm bg-white " id="overload">
                            <thead>
                                <tr>
                                    <th className="toi-primary text-center">Site ID</th>
                                    <th className="toi-primary text-center">Alarm Name</th>
                                    <th className="toi-primary text-center">Start Time</th>
                                    <th className="toi-primary text-center">End Time</th>
                                    <th className="toi-primary text-center">Elapsed Time</th>
                                    <th className="toi-primary text-center">Remark</th>
                         
                                </tr>
                            </thead>
                            <tbody>
                                {!loading && get_data?.alarms?.map((row, index) => (
                                    <tr>
                                        <td className="fs-11 text-info fw-bold text-center">{row.site_id}</td>
                                        <td className="fs-11 text-primary fw-bold text-center">{row.name}</td>
                                        <td className="fs-11 text-dark text-center">{row.alarm_start}</td>
                                        <td className="fs-11 text-dark text-center">{row.alarm_end}</td>
                                        <td className="fs-11 text-dark text-center">
                                            {row.alarm_end != null ?
                                                <span className="elisp_time">{row.total_elaspsed}</span>
                                                :
                                                <CountdownTimer targetDate={row.start} />
                                            }
                                        </td>
                                        <td className="text-left">
                                            <div className="d-flex">
                                                <div>
                                                    {row.command_type == 1 ?
                                                        <>
                                                            <p className="p-0 m-0 font-semibold">Organization: <span>{row.command_details?.organization}</span></p>
                                                            <p className="p-0 m-0 font-semibold">Name: <span>{row.command_details?.name}</span></p>
                                                            <p className="p-0 m-0 font-semibold">Phone: <span>{row.command_details?.phone}</span></p>
                                                            <p className="p-0 m-0 font-semibold">Job: <span>{row.command_details?.details}</span></p>
                                                        </>
                                                        : ''}
                                                </div>
                                                <div>
                                                    {row.command_type == 2 ?
                                                        <>
                                                            <p className="p-0 m-0 font-semibold">Organization: <span>{row.user?.vendor_name}</span></p>
                                                            <p className="p-0 m-0 font-semibold">Name: <span>{row.user?.name}</span></p>
                                                            <p className="p-0 m-0 font-semibold">Phone: <span>{row.user?.phone}</span></p>
                                                            <p className="p-0 m-0 font-semibold">Card: <span>{row.user?.card_number}</span></p>
                                                            <p className="p-0 m-0 font-semibold">Job: <span>{row.user?.job_name}</span></p>
                                                        </>
                                                        : ''}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>

                </div>

            </div>

        </>
    )
}